import { TimePicker } from "antd";
import { notify } from "@/shared/utils/notify";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useEffect } from "react";
import { Controller, FieldErrorsImpl } from "react-hook-form";

import { InputError } from "./styled";

dayjs.extend(customParseFormat);

interface PropsContent {
  errors: Partial<
    FieldErrorsImpl<{
      [x: string]: unknown;
    }>
  >;
  name: string;
}

const ErrorComponent = ({ errors, name }: PropsContent) => {
  useEffect(() => {
    if (errors?.[name]?.message) {
      notify.error(`${errors?.[name]?.message}`);
    }
  }, [errors, name]);

  return (
    <>
      {!!errors[name] && (
        <InputError>{errors?.[name]?.message}</InputError>
      )}
    </>
  );
};

interface Props {
  width?: string;
  placeHolder: string;
  name: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: any;
}

export const InputTimePicker = ({
  width = "100%",
  placeHolder,
  name,
  control,
}: Props) => {
  return (
    <Controller
      shouldUnregister
      control={control}
      name={name}
      render={({
        field: { onChange, value = "00:00:00" },
        formState: { errors },
      }) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              width,
              height: "80%",
              flexDirection: "column",
            }}
          >
            <TimePicker
              style={{ width: "100%" }}
              status={errors[name] ? "error" : ""}
              placeholder={placeHolder}
              onChange={(_time, timeString) => onChange(timeString)}
              value={value ? dayjs(value, "HH:mm:ss") : null}
            />
            <ErrorComponent errors={errors} name={name} />
          </div>
        );
      }}
    />
  );
};
